import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";


export default function DuplicateIcon(props: any) {
  const { style, viewBox, ...otherProps } = props;
  return (
    <SvgIcon
      {...otherProps}
      style={style || { width: 24, height: 24 }}
      viewBox={viewBox || "0 0 24 24"}
    >
      <path d="M17.6875 5H9.8125C9.07422 5 8.5 5.60156 8.5 6.3125V14.1875C8.5 14.9258 9.07422 15.5 9.8125 15.5H17.6875C18.3984 15.5 19 14.9258 19 14.1875V6.3125C19 5.60156 18.3984 5 17.6875 5ZM9.8125 16.375C8.58203 16.375 7.625 15.418 7.625 14.1875V8.5H6.3125C5.57422 8.5 5 9.10156 5 9.8125V17.6875C5 18.4258 5.57422 19 6.3125 19H14.1875C14.8984 19 15.5 18.4258 15.5 17.6875V16.375H9.8125Z"
        fill="#6462F3"
      />

    </SvgIcon>
  );
};
